import React, { useContext, useState } from 'react';
import swal from 'sweetalert';
import InputField from '../../../components/InputField';
import { userContext } from '../../../contextProvider/Authentication';
import axiosInstance from '../../../services/AxiosInstance';


function Feedback() {

    const [input, setInput] = useState({ description: "" });
    const { user } = useContext(userContext);

    const handleChange = (e) => {
        setInput({ [e.target.name]: e.target.value });
    }

    const handleSubmit = () => {
        input["created_by"] = user?.id;

        var url = input?.id ? `testimonials/${input?.id}/` : "testimonials/";
        var method = input?.id ? "PUT" : "POST";

        axiosInstance(
            url, {
            method: method,
            data: input
        }).then(res => {
            swal("", "Feedback submitted successfully!", "success", { button: "Ok" });
            setInput({ description: "" });
        }).catch(err => {
            swal("", Object.values(err.response.data).join(", "), "error", { button: "Ok" });
        })
    }

    return (
        <div className="job-bx job-profile">
            <div className="job-bx-title clearfix">
                <h5 className="font-weight-700 pull-left text-uppercase">Feedback</h5>
            </div>
            <InputField
                label="Description"
                textType='textarea'
                name="description"
                value={input?.description}
                required={true}
                onChange={(e) => handleChange(e)}
            />
            <button
                type="button"
                className="site-button mt-2"
                onClick={() => handleSubmit()}
                disabled={input?.description === "" ? true : false}
                style={{ backgroundColor: input?.description !== "" ? "#1d46f5" : "#8b99d5", cursor: input?.description !== "" ? "pointer" : "not-allowed" }}
            >
                Save
            </button>
        </div>
    );
}

export default Feedback;